import * as React from 'react';
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Button from '@material-ui/core/Button';
import Http from '../../../Http/Http';
import Constants from "../../../Action/Constants";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

import Link from '@material-ui/core/Link';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';

// interface PontoPanelProps {
//   bankAccountId?: string;
//   app?: any;
//   dispatch?: (action: any) => void;
// }

// type SynchronizationType = 'pending' | 'running' | 'error' | 'success';

class PontoPanel extends Component {
  constructor(public props: any) {
    super(props);
  }

  public handleConnectWithPontoClick = () => {
    // Bad quick fix. In the future, make modifications on History file,
    // so session storage history will get URL including parameters instead of just pathname.
    // We need to remove history from session storage in order to get parameters from URL.
    sessionStorage.removeItem("history");
    // Send location pathname to back end so back end can redirect user to specific page.
    // "dashboard" or "finance"
    const location = this.props?.location?.pathname.split("/")?.[2];
    Http.post(`bankAccount/createIntegration`, {
      pontoRedirectPlace: location
    })
      .then(res => {
        window.open(res.data.data.integrationUrl);
        this.props.setState({
          showPontoDialog: false
        });
      })
      .catch(err => {
        console.log('err', err);
        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("error/the-bank-account-was-not-linked"),
            type: "error"
          }
        });
      });
  }

  public openPontoExternalLink = () => {
    window.open(Constants.PONTO_EXTERNAL_WEBSITE_URL);
  }

  public handleInitSynchronization = () => {
    const { bankAccountId } = this.props;

    if (!bankAccountId) return;

    this.props.dispatch({
      type: Constants.PONTO_SYNCHRONIZATION_BUTTON_DISABLED,
      payload: true
    });


    this.props.dispatch({
      type: Constants.GLOBAL_PONTO_SYNCHRONIZE,
      payload: {
        bankAccountId
      },
      onError: err => {
        if (err?.errorId === "account_recently_synchronized") {
          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("account_recently_synchronized"),
              type: "error"
            }
          });
        }
      }
    });
  }

  public uploadFile = () => {
    this.props.closeMenu();
    this.props.openBankTransactionsDilaog()
  }
  public handleRevokeAccess = () => {
    this.props.setState({
      isSaving: true
    });

    this.props.closeMenu();

    this.props.dispatch({
      type: Constants.GLOBAL_PONTO_REVOKE_ACCESS,
      onSuccess: () => {
        this.props.setState({
          isSaving: false
        })
      },
      onError: (err) => {
        return this.props.setState({
          showPontoDisconnectErrorDialog: true,
          pontoDisconnectErrorId: err?.errorId,
          isSaving: false
        })
      }
    });
  }

  public render() {
    const {
      pontoIntegration
    } = this.props;

    if (!pontoIntegration?.isConnected) {
      return (
        <>
          <Button
            onClick={() => {
              this.props.setState({
                showPontoDialog: true
              });
            }}
            variant="outlined"
            color="primary"
            style={{ margin: '0 20px' }}
          >
            {this.trans("connect-to-ponto-button")}
          </Button>
        
          <PromptDialog
            {...this.props}
            title={this.trans("ponto-informational-title")}
            content={
              <>
                <p>{this.trans("ponto-informational-content1")}</p>
                <p>
                  {this.trans("ponto-informational-content2")}
                  <Link
                    onClick={this.openPontoExternalLink}
                  >
                    {this.trans("ponto-informational-content2-link")}
                  </Link>
                </p>
              </>
            }
            innerDialogClasses="coach-owner dialog-assistant"
            negativeButtonLabel={this.trans("dialog-button/cancel")}
            positiveButtonLabel={this.trans("dialog-button/continue")}
            openLeavePrompt={this.props.showPontoDialog}
            prioritizeClosing={true}
            onDiscard={() => {
              this.props.setState({
                showPontoDialog: false
              });
            }}
            onSave={this.handleConnectWithPontoClick}
          />
        </>
      );
    }

    const {
      synchronizationStatus,
      lastSuccessfulSynchronizationDate,
      lastCountOfCreatedPayments,
    } = pontoIntegration;

    return (
      <div style={{ display: "flex", flexDirection: "column", paddingTop: 0, justifyContent: "flex-start" }}>
      <div style={{ display: "flex", alignItems: "center", paddingTop: 0 }}>
        
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleInitSynchronization}
            disabled={this.props?.app?.pontoSynchronizeButtonDisabled}
          >
            {this.props?.app?.pontoSynchronizeButtonDisabled ? this.trans("status/fetching") : this.trans("syncronize-with-ponto-button")}
          </Button>
        <div /* style={{ marginLeft: "12px" }} */>
          <IconButton
          style={{ padding: 0 }}
            onClick={e => this.props.setState({
              anchorEl: e?.currentTarget,
              openPontoMenu: true
            })}
          >
            <div className="icon icon-ic-more-vert"></div>
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={this.props.anchorEl}
            open={Boolean(this.props.anchorEl) && this.props.openPontoMenu}
            onClose={this.props.closeMenu}
            disableAutoFocusItem={true}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left"
            }}
            getContentAnchorEl={null}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>

              <Button
                style={{ margin: "5px 10px" }}
                variant="contained"
                // color="primary"
                onClick={this.handleRevokeAccess}
              >
                {this.trans("revoke-access-from-ponto-button")}
              </Button>
              <Button
                style={{ margin: "5px 10px" }}
                color="primary"
                variant="contained"
                onClick={this.uploadFile}
              >
                {this.trans("upload-mt940-file")}
              </Button>
            </div>
          </Menu>
        </div>
        </div>
        {(synchronizationStatus === 'success' || synchronizationStatus === 'error') && (
            <div style={{display: "flex", flexDirection: "column" }}>
              <span style={{ margin: "10px 0" }}>
                {lastSuccessfulSynchronizationDate ? `${this.trans("ponto_count_of_created_payments", { count: lastCountOfCreatedPayments ? lastCountOfCreatedPayments : 0 })} ${this.formatter.formatTimeAndDate(new Date(lastSuccessfulSynchronizationDate)) }` : ""}
              </span>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  PontoPanel
);
